import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Anime%20art%20style%20illustration%20with%20warm%20orange%20and%20coral%20toned%20sky%2C%20cherry%20blossom%20petals%20floating%20in%20the%20air%2C%20silhouette%20of%20a%20Japanese%20torii%20gate%20and%20distant%20mountains%2C%20soft%20dreamy%20atmosphere%2C%20cinematic%20lighting%2C%20clean%20artistic%20composition%2C%20flat%20illustration%20style%20with%20gradient%20colors%2C%20no%20text%2C%20no%20characters&width=1800&height=1000&seq=hero-bg-main&orientation=landscape"
        alt="奶片动漫 - 你的专属动漫追番基地"
        title="奶片动漫 - 热门新番高清追番平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-black text-white mb-4 leading-tight">
            你的专属<strong className="text-primary-400">动漫追番基地</strong>
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            涵盖热门新番、经典老番、国漫、日漫等海量资源，高清流畅播放，让每一位动漫迷找到属于自己的二次元世界
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category"
              className="px-8 py-3 bg-primary-500 text-white rounded-full font-medium text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即追番
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full font-medium text-sm md:text-base hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}